module.exports = __webpack_public_path__ + "img/security at the mansion.18313cd3.png";